import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "@phosphor-icons/react";

// Alumni Impact — badges, level and "My Alumni Impact" timeline.
// self=true uses /me/impact (all statuses); otherwise /users/{userId}/impact (public only).
export default function AlumniImpact({ userId, self = false }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    const url = self ? "/me/impact" : `/users/${userId}/impact`;
    api.get(url).then((r) => setData(r.data)).catch(() => setData(false));
  }, [userId, self]);

  if (!data || data === false) return null;
  const hasAny = (data.badges?.length || 0) > 0 || (data.timeline?.length || 0) > 0;
  if (!hasAny) return null;

  return (
    <section className="rounded-2xl border border-border/60 bg-white p-5 sm:p-6" data-testid="alumni-impact">
      <div className="flex items-center gap-2">
        <Trophy size={20} weight="duotone" className="text-secondary" />
        <h3 className="font-heading text-xl font-medium">My Alumni Impact</h3>
        {data.level && <span className="ml-auto rounded-full bg-secondary/15 px-3 py-1 text-xs font-semibold text-secondary" data-testid="impact-level">{data.level}</span>}
      </div>

      {data.badges?.length > 0 && (
        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3" data-testid="impact-badges">
          {data.badges.map((b) => (
            <div key={b.key} className="flex items-center gap-2 rounded-xl border border-border/60 p-2.5" title={b.desc}>
              <span className="text-xl">{b.icon}</span>
              <div className="min-w-0">
                <div className="truncate text-sm font-medium">{b.label}</div>
                {b.count > 1 && <div className="text-[11px] text-muted-foreground">×{b.count}</div>}
              </div>
            </div>
          ))}
        </div>
      )}

      {data.timeline?.length > 0 && (
        <div className="mt-5">
          <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Timeline</div>
          <div className="mt-2 space-y-2">
            {data.timeline.slice(0, 12).map((t, i) => (
              <div key={i} className="flex items-center gap-2 text-sm">
                <span className="w-12 shrink-0 text-xs text-muted-foreground">{(t.created_at || "").slice(0, 4)}</span>
                <span className="font-medium">{t.help_label}</span>
                {t.institution_name && <span className="truncate text-muted-foreground">· {t.institution_name}</span>}
                {self && t.status && <span className="ml-auto shrink-0 rounded-full bg-muted px-2 py-0.5 text-[10px] capitalize text-muted-foreground">{t.status.replace("_", " ")}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
